// @ts-nocheck

import type { KochavaAttributionMode } from '../../../types/adPartnerTypes';

export const ATTRIBUTION_MODE: { [key: string]: KochavaAttributionMode } = {
  VTA: 'VTA',
  CTA: 'CTA',
  BMA: 'BMA',
};

export const RokuDefaultsData = {
  roku_channel_id: '',
  attribution_mode: ATTRIBUTION_MODE.BMA,
  match_by: {
    device_id: false,
    fingerprint: false,
    full_ip: false,
    partial_ip: false,
    properties: false,
  },
  properties: [],
};

const RokuDefaults = {
  ATTRIBUTION_MODE: ATTRIBUTION_MODE,
  Data: RokuDefaultsData,
};
export default RokuDefaults;
